module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/ministerioconsumo-1.webp?e1696767";